<payee-popup title="{{ 'MULTI_UPLOAD_RESULT_DIALOG.TITLE' | translate }}">
  @if (data.skippedFileNames.length) {
    <section class="panel skipped-panel">
      <h2 class="panel-title">
        {{ "MULTI_UPLOAD_RESULT_DIALOG.SKIPPED_TITLE" | translate }}
      </h2>
      <ul class="file-list">
        @for (fileName of data.skippedFileNames; track fileName) {
          <li>{{ fileName }}</li>
        }
      </ul>
    </section>
  }

  @if (showCurrentCaseOption || data.debtorGroups.length) {
    <section class="panel debtor-selection-panel">
      <h2 class="panel-title">
        {{ "MULTI_UPLOAD_RESULT_DIALOG.DEBTOR_SELECTION_TITLE" | translate }}
      </h2>
      <p class="panel-lead">
        {{ "MULTI_UPLOAD_RESULT_DIALOG.SELECT_DEBTOR_HINT" | translate }}
      </p>

      @if (showCurrentCaseOption) {
        <article
          class="debtor-group-card debtor-group-card--selectable"
          role="button"
          tabindex="0"
          [class.debtor-group-card--selected]="selectedDebtorGroupIndex === 0"
          (click)="selectDebtorGroup(0)"
          (keydown.enter)="selectDebtorGroup(0)"
          (keydown.space)="selectDebtorGroup(0); $event.preventDefault()"
        >
          <header class="debtor-group-header">
            <input
              type="radio"
              class="debtor-group-radio"
              [checked]="selectedDebtorGroupIndex === 0"
              (click)="$event.stopPropagation()"
              (change)="selectDebtorGroup(0)"
            />
            <div class="debtor-group-title">
              @if (data.currentCase.debtor_name?.trim()) {
                <span class="debtor-name">{{ data.currentCase.debtor_name }}</span>
              } @else {
                <span class="debtor-name debtor-name--placeholder">
                  {{ "MULTI_UPLOAD_RESULT_DIALOG.DEBTOR_NOT_SET" | translate }}
                </span>
              }
              @if (data.currentCase.debtor_tax_number) {
                <span class="debtor-tax">
                  {{ data.currentCase.debtor_tax_number }}
                </span>
              }
            </div>
            <span class="invoice-count">
              {{ "MULTI_UPLOAD_RESULT_DIALOG.INVOICE_COUNT" | translate: { count: data.currentCase.claims.length } }}
            </span>
          </header>
          @if (data.currentCase.claims.length) {
            <ol class="claim-list">
              @for (claim of data.currentCase.claims; track claim.fileName) {
                <li class="claim-item">
                  <span class="claim-file-name">{{ claim.fileName }}</span>
                  <span class="claim-meta">
                    <span class="claim-amount">{{ claim.amountLabel }}</span>
                    <span class="claim-due-date">{{ claim.dueDate }}</span>
                  </span>
                </li>
              }
            </ol>
          }
        </article>
      }

      @for (group of data.debtorGroups; track groupIndex; let groupIndex = $index) {
        <article
          class="debtor-group-card debtor-group-card--selectable"
          role="button"
          tabindex="0"
          [class.debtor-group-card--selected]="selectedDebtorGroupIndex === getDebtorGroupOptionIndex(groupIndex)"
          (click)="selectDebtorGroup(getDebtorGroupOptionIndex(groupIndex))"
          (keydown.enter)="selectDebtorGroup(getDebtorGroupOptionIndex(groupIndex))"
          (keydown.space)="selectDebtorGroup(getDebtorGroupOptionIndex(groupIndex)); $event.preventDefault()"
        >
          <header class="debtor-group-header">
            <input
              type="radio"
              class="debtor-group-radio"
              [checked]="selectedDebtorGroupIndex === getDebtorGroupOptionIndex(groupIndex)"
              (click)="$event.stopPropagation()"
              (change)="selectDebtorGroup(getDebtorGroupOptionIndex(groupIndex))"
            />
            <div class="debtor-group-title">
              <span class="debtor-name">{{ group.debtor_name ?? "-" }}</span>
              @if (group.debtor_tax_number) {
                <span class="debtor-tax">
                  {{ group.debtor_tax_number }}
                </span>
              }
            </div>
            <span class="invoice-count">
              {{ "MULTI_UPLOAD_RESULT_DIALOG.INVOICE_COUNT" | translate: { count: group.parsedInvoices.length } }}
            </span>
          </header>
          @if (group.parsedInvoices.length) {
            <ol class="claim-list">
              @for (parsed of group.parsedInvoices; track parsed.fileName) {
                <li class="claim-item">
                  <span class="claim-file-name">{{ parsed.fileName }}</span>
                  <span class="claim-meta">
                    <span class="claim-amount">{{ parsed.amountLabel }}</span>
                    <span class="claim-due-date">{{ parsed.dueDate }}</span>
                  </span>
                </li>
              }
            </ol>
          }
        </article>
      }
    </section>
  }

  <ng-template #payeePopupSubmitTemplate>
    <div class="submit-actions">
      @if (canAddAllClaims) {
        <button
          payee-button
          color="white"
          width="max"
          height="tall"
          data-testid="ocr-keep-debtor"
          [isBorderButton]="true"
          (click)="addAllClaims()"
        >
          {{ addAllClaimsLabelKey | translate }}
        </button>
      }
      <button
        payee-button
        color="blue-payee"
        width="max"
        height="tall"
        data-testid="ocr-apply-debtor"
        [disabled]="selectedDebtorGroupIndex === null"
        (click)="apply()"
      >
        {{ applyLabelKey | translate }}
      </button>
    </div>
  </ng-template>

  <ng-template #payeePopupCancelTemplate></ng-template>
</payee-popup>
